import { keyframes, style, styleVariants } from "@vanilla-extract/css";

import { text } from "~/styles/type.css";
import { vars } from "~/styles/tokens.css";

export const wrapper = style({
  display: "inline-flex",
  alignItems: "center",
  gap: vars.space.sm,
});

const pulse = keyframes({
  "0%": { opacity: 1 },
  "50%": { opacity: 0.45 },
  "100%": { opacity: 1 },
});

const dotBase = style({
  width: "8px",
  height: "8px",
  borderRadius: vars.radius.full,
  flexShrink: 0,
});

// Only `active` pulses (2s, subtle) — it means "live right now".
// styles/reduced-motion.css collapses it to a static dot; no guard here.
const activePulse = style({
  animation: `${pulse} 2s ease-in-out infinite`,
});

export const dot = styleVariants({
  active: [dotBase, activePulse, { backgroundColor: vars.color.statusActive }],
  waiting: [dotBase, { backgroundColor: vars.color.statusWaiting }],
  scheduled: [dotBase, { backgroundColor: vars.color.statusScheduled }],
  idle: [dotBase, { backgroundColor: vars.color.statusIdle }],
  breach: [dotBase, { backgroundColor: vars.color.statusBreach }],
});

export const label = style([
  text.micro,
  {
    color: vars.color.textMuted,
  },
]);
